<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <h3>Box3 代码工具</h3>
    </v-app-bar>

    <v-main>

      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
};
</script>
<style lang="sass">
html,body
  user-select: none
  overflow-y: auto !important
</style>